import { render, staticRenderFns } from "./Fileinput.vue?vue&type=template&id=6636b009&scoped=true&"
import script from "./Fileinput.vue?vue&type=script&lang=js&"
export * from "./Fileinput.vue?vue&type=script&lang=js&"
import style0 from "./Fileinput.vue?vue&type=style&index=0&id=6636b009&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6636b009",
  null
  
)

export default component.exports